module.exports = __webpack_public_path__ + "static/menu_calendar-7d151160902ca237fabb4d71fab1cbc3.png";